/* eslint-disable camelcase */
import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/core'
import {getTheme, getThemeStyles} from '../util/theme'
import {getLanguageCode} from '../util/locale'

import Layout from '../components/Layout'
import AboutHero from '../components/about/AboutHero'
import AboutSubsection1 from '../components/about/AboutSubsection1'
import AboutSubsection2 from '../components/about/AboutSubsection2'
import AboutSubsection3 from '../components/about/AboutSubsection3'
import AboutFooter from '../components/about/AboutFooter'

import aboutUsTranslations from '../translations/aboutUs.json'

const AboutUs = ({languageCode}) => {
    const lang = languageCode || getLanguageCode()

    const {aboutSeo, aboutSection1Subtitle} = aboutUsTranslations[lang]

    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState(getThemeStyles('light'))

    useEffect(() => {
        const resolvedTheme = getTheme()
        setTheme(resolvedTheme)
        setThemeStyles(getThemeStyles(resolvedTheme))
    }, [])

    return (
        <Layout
            title={aboutSeo.title}
            description={aboutSeo.description}
            lang={lang}
            canonicalPath="/about-us/"
            themeStyles={themeStyles}
            theme={theme}
            bannerTitle={aboutSection1Subtitle}
            headerOverrideStyles={css`
                box-shadow: none;
                div.privacy-hamburger-container {
                    margin-left: 72px;
                }
                @media (${themeStyles.breakPoints.mobile}) {
                    padding: 26px 16px;
                    justify-content: center;
                    height: 76px;

                    div.header-title {
                        display: none;
                    }
                    div.privacy-hamburger-container {
                        position: absolute;
                        right: 16px;
                        margin-bottom: 5px;
                    }
                }
            `}
            noFooter
        >
            <AboutHero themeStyles={themeStyles} lang={lang} />
            <AboutSubsection1 lang={lang} themeStyles={themeStyles} />
            <AboutSubsection2 lang={lang} themeStyles={themeStyles} />
            <AboutSubsection3 lang={lang} themeStyles={themeStyles} />
            <AboutFooter themeStyles={themeStyles} lang={lang} />
        </Layout>
    )
}

AboutUs.propTypes = {
    languageCode: PropTypes.string,
}

export default AboutUs
